import { gql } from "@apollo/client";

export const ACTIVE_SENTRY_SESSION_QUERY = gql`
    query {
        activeSentrySessionCheckin {
            sessionId
            hasActiveSession
            checkedIn
        }
    }
`;

export const ACTIVE_SPOILS_SESSION_QUERY = gql`
    query {
        activeSpoilsSessionStatus {
            sessionId
            hasActiveSession
            hasRedeemed
        }
    }
`;

export const ACTIVE_DRINK_SESSION_QUERY = gql`
    query {
        activeDrinkSessionStatus {
            sessionId
            hasActiveSession
            hasRedeemed
        }
    }
`;

export const ACTIVE_CLAN_SPOILS_SESSION_QUERY = gql`
    query {
        activeClanSpoilsSessionStatus {
            sessionId
            hasActiveSession
            hasRedeemed
        }
    }
`;

export const ACTIVE_CLAN_SPOILS_SESSION_QUERY_FOR_CLAN = gql`
    query ActiveClanSpoilsSessionForClan($clanTag: String!) {
        activeClanSpoilsSessionStatus(clanTag: $clanTag) {
            sessionId
            hasActiveSession
            hasRedeemed
        }
    }
`;

export const ACTIVE_CHECKIN_SESSION_QUERY = gql`
    query {
        activeCheckinSessionStatus {
            checkedIn
            hasActiveSession
            sessionId
        }
    }
`;

export const ACTIVE_RAID_SESSION_QUERY = gql`
    query {
        activeRaidSessionStatus {
            sessionId
            hasActiveSession
            checkedIn
        }
    }
`;

export const ACTIVE_HYPE_TRAIN_LOOT_SESSION_QUERY = gql`
    query ActiveHypeTrainLootSessionQuery {
        activeHypeTrainLootSession {
            hasActiveSession
            sessionId
            redeemed
        }
    }
`;

export const ACTIVE_WHEEL_OF_HAMINGJA_REDEMPTION_SESSION_QUERY = gql`
    query ActiveWheelOfHamingjaRedemptionSessionQuery {
        activeWheelOfHamingjaRedemptionSessionStatus {
            hasActiveSession
            hasAvailableTokens
            sessionId
        }
    }
`;

export const ACTIVE_WHEEL_OF_HAMINGJA_SESSION_QUERY = gql`
    query ActiveWheelOfHamingjaSessionQuery {
        activeWheelOfHamingjaSessionQueryStatus {
            claimed
            hasActiveSession
            sessionId
        }
    }
`;
